export default __webpack_public_path__ + "static/aicase1-e9125b14b119c7158b995c361bfa875a.png";